import { configureStore } from '@reduxjs/toolkit';
import eventReducer from '../features/event/eventSlice';
import venueReducer from '../features/venue/venueSlice';
import gameFormatReducer from '../features/gameFormat/gameFormatSlice';
import gameReducer from '../features/game/gameSlice';
import leaderboardReducer from '../features/leaderboard/leaderboardSlice';
import playerReducer from '../features/player/playerSlice';
import teamReducer from '../features/team/teamSlice';
import alertReducer from '../features/alert/alertSlice';
import userReducer from '../features/user/userSlice';
import bracketReducer from '../features/bracket/bracketSlice';
import tournamentReducer from '../features/tournament/tournamentSlice';
import greenService from '../features/green/greenSlice';
import publicScoringReducer from '../features/publicScoring/publicScoringSlice';
import workspaceReducer from '../features/workspace/workspaceSlice';
import rankingReducer from '../features/ranking/rankingSlice';

const store = configureStore({
  reducer: {
    event: eventReducer,
    venue: venueReducer,
    game: gameReducer,
    gameFormat: gameFormatReducer,
    leaderboard: leaderboardReducer,
    player: playerReducer,
    team: teamReducer,
    alert: alertReducer,
    user: userReducer,
    bracket: bracketReducer,
    tournament: tournamentReducer,
    green: greenService,
    publicScoring: publicScoringReducer,
    workspace: workspaceReducer,
    ranking: rankingReducer
  },
  //devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;
